/* eslint-disable no-param-reassign */
import React from 'react';

// Style
import './image.scss';

const Image = ({
  img,
  alt,
  height = '100%',
  radius,
  radiusBottomLeft,
  radiusBottomRight,
  radiusTopLeft,
  radiusTopRight,
  customClass,
  fallbackImage,
}) => {
  let image = img;
  if (image && image.startsWith('https://res.cloudinary.com')) {
    const optimizatedImage = image.split('images/');
    image = `${optimizatedImage[0]}images/f_auto,q_auto/${optimizatedImage[1]}`;
  }

  const getFallbackImage = (event) => {
    const defaultImage =
      'https://res.cloudinary.com/hebu10lmu/image/upload/f_auto,q_auto/v1611497968/www/default_mrgzfs.png';
    if (event && event.target) {
      event.target.src = fallbackImage || defaultImage;
    }
  };

  return (
    <figure
      className={customClass ? `${customClass} cover-image` : 'cover-image'}
      style={{ height }}
    >
      <img
        loading="lazy"
        onError={getFallbackImage}
        src={image}
        alt={alt}
        style={{
          borderRadius: radius,
          borderBottomLeftRadius: radiusBottomLeft,
          borderBottomRightRadius: radiusBottomRight,
          borderTopLeftRadius: radiusTopLeft,
          borderTopRightRadius: radiusTopRight,
        }}
      />
    </figure>
  );
};

export default Image;
